import {minmax, sectionToFixedMap, portrait} from '../shared.js';

import {
  buildNarrativeTextTimeline,
  dashPaths,
  animateCallout,
  animatePages,
  animateTextHighlights,
} from '../animations.js';

const article = document.querySelector('#chapter8');

const narrativeSection = article.querySelector('#chapter8-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const nscSection = article.querySelector('#chapter8-infographic-nsc');
const nscFixed = sectionToFixedMap.get(nscSection);
const nscCallout = nscFixed.querySelector('#ch8-nsc-callout');
const nscFootnote = nscFixed.querySelector('.footnote');
const nscPages = Array.from(nscFixed.querySelectorAll('.declassified-page'));
const nscPathHighlights = Array.from(nscFixed.querySelectorAll('figure svg path'));
const nscQuote = nscFixed.querySelector('#ch8-nsc-quote');
const nscTimeline = new TimelineLite({paused: true});

const fbiSection = article.querySelector('#chapter8-infographic-fbi');
const fbiFixed = sectionToFixedMap.get(fbiSection);
const fbiCurtain = fbiFixed.querySelector('.blackout-curtain');
const fbi = fbiFixed.querySelector('.fbi');
const fbiConflict = fbi.querySelector('.conflict');
const fbiMemoCallout = fbiFixed.querySelector('#ch8-fbi-memo-callout');
const fbiFootnote = fbiFixed.querySelector('.footnote');
const fbiPages = Array.from(fbiFixed.querySelectorAll('.declassified-page'));
const fbiHighlightPaths = Array.from(fbiFixed.querySelectorAll('figure svg path'));
const fbiMemoQuote = fbiFixed.querySelector('#ch8-fbi-memo-quote');
const fbiTimeline = new TimelineLite({paused: true});
const fbiTimelinePortrait = new TimelineLite({paused: true});

const ciaSection = article.querySelector('#chapter8-infographic-cia');
const ciaFixed = sectionToFixedMap.get(ciaSection);
const ciaCurtain = ciaFixed.querySelector('.blackout-curtain');
const cia = ciaFixed.querySelector('.cia');
const ciaConflict = cia.querySelector('.conflict');
const ciaTextHighlights = Array.from(ciaConflict.querySelectorAll('.highlight'));
const ciaBriefCallout = ciaFixed.querySelector('#ch8-cia-brief-callout');
const ciaFootnote = ciaFixed.querySelector('.footnote');
const ciaPages = Array.from(ciaFixed.querySelectorAll('.declassified-page'));
const ciaPathHighlights = Array.from(ciaFixed.querySelectorAll('figure svg path'));
const ciaBriefQuote = ciaFixed.querySelector('#ch8-cia-brief-quote');
const ciaTimeline = new TimelineLite({paused: true});
const ciaTimelinePortrait = new TimelineLite({paused: true});

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter8:init');

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initNSC();
  initFBI();
  initCIA();
}

/**
 * Setup NSC section
 */
function initNSC() {
  TweenLite.set([nscCallout, nscQuote, nscFootnote, ...nscPages], {opacity: 0});
  TweenLite.set(nscPages, {scale: 1.5});

  dashPaths(nscPathHighlights);

  nscTimeline.to({}, 100, {});

  animateCallout(nscCallout, nscTimeline);

  nscTimeline.to({}, 25, {});

  nscTimeline.to(nscFootnote, 25, {opacity: 1});

  animatePages(nscPages, nscTimeline);

  nscTimeline.to(nscQuote, 50, {opacity: 1});
  nscSection.addEventListener('scrub', ({detail: {vh}}) => nscTimeline.seek(minmax(0, vh, nscTimeline.duration()), false));
}

/**
 * Setup FBI section
 */
function initFBI() {
  TweenLite.set([fbiConflict, fbiMemoCallout, fbiFootnote, fbiMemoQuote, ...fbiPages], {opacity: 0});
  TweenLite.set([fbiConflict, fbiMemoCallout], {x: '-=25%'});
  TweenLite.set(fbiPages, {scale: 1.5});

  dashPaths(fbiHighlightPaths);

  fbiTimeline.to({}, 100, {});

  fbiTimeline.to(fbiCurtain, 50, {left: '50%'});
  fbiTimeline.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  fbiTimeline.to({}, 25, {});

  fbiTimeline.add([
    TweenLite.to(fbiCurtain, 50, {left: '100%'}),
    TweenLite.to(fbiConflict, 25, {opacity: 0, x: '+=25%'}),
  ]);

  animateCallout(fbiMemoCallout, fbiTimeline);

  fbiTimeline.to({}, 25, {});

  fbiTimeline.to(fbiFootnote, 25, {opacity: 1});

  animatePages(fbiPages, fbiTimeline);

  fbiTimeline.to(fbiMemoQuote, 25, {opacity: 1});

  fbiTimelinePortrait.to({}, 100, {});

  fbiTimelinePortrait.to(fbiCurtain, 50, {left: '100%'});
  fbiTimelinePortrait.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  fbiTimelinePortrait.to({}, 25, {});

  fbiTimelinePortrait.add([
    TweenLite.to(fbiConflict, 25, {opacity: 0, x: '+=25%'}),
  ]);

  animateCallout(fbiMemoCallout, fbiTimelinePortrait);

  fbiTimelinePortrait.to({}, 25, {});

  fbiTimelinePortrait.to(fbiFootnote, 25, {opacity: 1});

  animatePages(fbiPages, fbiTimelinePortrait);

  fbiTimelinePortrait.to(fbiMemoQuote, 25, {opacity: 1});

  fbiSection.addEventListener('scrub', ({detail: {vh}}) => {
    if (portrait.matches) {
      fbiTimelinePortrait.seek(minmax(0, vh, fbiTimelinePortrait.duration()), false);
    } else {
      fbiTimeline.seek(minmax(0, vh, fbiTimeline.duration()), false);
    }
  });
}

/**
 * Setup CIA section
 */
function initCIA() {
  TweenLite.set([ciaConflict, ciaBriefCallout, ciaFootnote, ciaBriefQuote, ...ciaPages], {opacity: 0});
  TweenLite.set([ciaConflict, ciaBriefCallout], {x: '+=25%'});
  TweenLite.set(ciaPages, {scale: 1.5});

  dashPaths(ciaPathHighlights, ciaTimeline);

  ciaTimeline.to({}, 100, {});

  ciaTimeline.to(ciaCurtain, 50, {right: '50%'});
  ciaTimeline.to(ciaConflict, 25, {opacity: 1, x: '0%'});

  ciaTimeline.to({}, 25, {});

  animateTextHighlights(ciaTextHighlights, ciaTimeline);

  ciaTimeline.to({}, 50, {});

  ciaTimeline.add([
    TweenLite.to(ciaCurtain, 50, {right: '100%'}),
    TweenLite.to(ciaConflict, 25, {opacity: 0, x: '-=25%'}),
  ]);

  animateCallout(ciaBriefCallout, ciaTimeline);

  ciaTimeline.to({}, 25, {});

  ciaTimeline.to(ciaFootnote, 25, {opacity: 1});

  animatePages(ciaPages, ciaTimeline);

  ciaTimeline.to(ciaBriefQuote, 25, {opacity: 1});
  ciaTimeline.to(ciaBriefQuote, 50, {backgroundColor: 'black'});

  ciaTimelinePortrait.to({}, 100, {});

  ciaTimelinePortrait.to(ciaCurtain, 50, {right: '100%'});
  ciaTimelinePortrait.to(ciaConflict, 25, {opacity: 1, x: '0%'});

  ciaTimelinePortrait.to({}, 25, {});

  animateTextHighlights(ciaTextHighlights, ciaTimelinePortrait);

  ciaTimelinePortrait.to({}, 50, {});

  ciaTimelinePortrait.add([
    TweenLite.to(ciaConflict, 25, {opacity: 0, x: '-=25%'}),
  ]);

  animateCallout(ciaBriefCallout, ciaTimelinePortrait);

  ciaTimelinePortrait.to({}, 25, {});

  ciaTimelinePortrait.to(ciaFootnote, 25, {opacity: 1});

  animatePages(ciaPages, ciaTimelinePortrait);

  ciaTimelinePortrait.to(ciaBriefQuote, 25, {opacity: 1});
  ciaTimelinePortrait.to(ciaBriefQuote, 50, {backgroundColor: 'black'});

  ciaSection.addEventListener('scrub', ({detail: {vh}}) => {
    if (portrait.matches) {
      ciaTimelinePortrait.seek(minmax(0, vh, ciaTimelinePortrait.duration()), false);
    } else {
      ciaTimeline.seek(minmax(0, vh, ciaTimeline.duration()), false);
    }
  });
}
